/**
 * /tenant-plane — "Workspace" (TenantPlane). Surface Layer (/01)
 *
 * REQ-001.74H-R5-UI. The user/client-facing workspace surface. At the index
 * it renders tenant-scoped workspace/file/RAG/request/status UI from the BFF
 * seam; child Spoke routes still render via the Outlet.
 */

import { createFileRoute, Outlet, useChildMatches } from '@tanstack/react-router';
import { UserHubWorkspace } from '../components/workspace/UserHubWorkspace';

function TenantPlaneRoute() {
  // Render the landing only at the index; a child match (a Spoke host) replaces it.
  const hasChild = useChildMatches().length > 0;
  return hasChild ? <Outlet /> : <UserHubWorkspace />;
}

export const Route = createFileRoute('/tenant-plane')({
  component: TenantPlaneRoute,
});
